import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GSuiteSvg = function GSuiteSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M21.821 10.113h-9.618v3.75h5.817a6.02 6.02 0 0 1-2.233 3.2 5.84 5.84 0 0 1-3.456 1.187c-2.686-.028-5.054-1.734-5.881-4.237a5.87 5.87 0 0 1 0-3.938c.901-2.42 3.252-4.028 5.88-4.025a5.85 5.85 0 0 1 3.827 1.388l2.781-2.763A9.63 9.63 0 0 0 12.203 2c-3.855.03-7.37 2.167-9.108 5.538a9.65 9.65 0 0 0 .064 9.05c1.763 3.302 5.24 5.384 9.044 5.412a9.64 9.64 0 0 0 6.595-2.563A10.07 10.07 0 0 0 22 12a10.5 10.5 0 0 0-.179-1.887"
  }));
};
export var GSuite = function GSuite(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GSuiteSvg
  }));
};